/* eslint-disable camelcase */
import { BaseDate } from '@/app/shared/utils/Date'

export default class ActivationItemIndex {
  constructor ({ id, name, created_at, created_by }) {
    this.id = id
    this.name = name || ''
    this.created_at = new BaseDate(created_at)
    this.createdBy = created_by ? created_by.full_name : ''
  }
}



// WEBPACK FOOTER //
// ./src/app/activations/models/ActivationItemIndex.js